import React from 'react';
import { useTranslation } from 'react-i18next';
import { useMerchants } from '../../../store/merchnts/merchants-context';
import { SectionWrapper } from '../../../components/SectionWrapper';
import { IModalWindow, ModalWindow } from '../../../components/modal/ModalWindow';
import { UpdateComponent } from '../../../components/merchants/MerchantPage/withMerchantDetails';
import { FormInput } from '../../../components/merchants/FormInput';
import { InputType } from '../../../components/form/form-input-constants';

interface ISpecialTermsProps {
	isEditMode: boolean;
	setIsEditMode: (value:boolean) => void;
	isLoading: boolean;
	modalState: IModalWindow;
	closeModal: () => void;
	formik: any;
	onEditClick: () => void;
	onCancelClick?: () => void;
}

const MerchantSpecialTermsPage = (props: ISpecialTermsProps): JSX.Element => {
	const { isEditMode, setIsEditMode, isLoading, modalState, closeModal, formik, onEditClick, onCancelClick } = props;

	const { t } = useTranslation();
	const { merchantState: { isMerchantDataLoading, merchantData }} = useMerchants();

	const showPlaceholder = !merchantData || typeof merchantData === 'object' && Object.keys(merchantData).length === 0 || typeof merchantData !== 'object';

	return (
		<>
			<SectionWrapper
				showPlaceholder={showPlaceholder}
				title={t('MERCHANT.SPECIAL_TERMS')}
				sectionAdditionalClass="mb-5 min-height-200"
				isEditMode={isEditMode}
				setIsEditMode={setIsEditMode}
				onEditClick={onEditClick}
				onCancelClick={onCancelClick}
				loading={isLoading}
				pageLoading={isMerchantDataLoading}
				isCardBody
				isEditBlock={!showPlaceholder}
			>
				<div className="row">
					<FormInput
						formik={formik}
						fieldName='MerchantSpecialTermsPage'
						// label={t(FORM_FIELDS_NAMES.SPECIAL_TERMS)}
						placeholder={t('NEW_APPLICATION.SPECIAL_TERMS_DESCRIPTION_PLACEHOLDER')}
						inputType={InputType.Editor}
						isEditMode={isEditMode}
						key='MerchantSpecialTermsPage'
					/>
				</div>
			</SectionWrapper>
			<ModalWindow
				{...modalState}
				onClose={closeModal}
			/>
		</>
	);
};

export default UpdateComponent(MerchantSpecialTermsPage, 'special-terms');
